import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Tooltip } from '@wix/design-system';

interface PurchaseButtonWrapperOuter {
  showPricesWithTax: boolean;
  displayTaxType: string;
}

export const PurchaseButtonWrapper: FC<PurchaseButtonWrapperOuter> = ({
  showPricesWithTax,
  displayTaxType,
  children,
}) => {
  return showPricesWithTax ? (
    <Tooltip
      content={
        <FormattedMessage
          id="shutterstock.item.price_includes_tax"
          values={{ taxType: <FormattedMessage id={`taxes.${displayTaxType}`} /> }}
        />
      }
    >
      {children}
    </Tooltip>
  ) : (
    <>{children}</>
  );
};
